export default {
  state: {
    user: null,
    company: null,
    refreshInterval: null
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload;
    },
    unsetUser(state) {
      state.user = null;
    },
    setCompany(state, payload) {
      state.company = payload;
    },
    unsetCompany(state) {
      state.company = null;
    },
    setRefreshInterval(state, interval) {
      state.refreshInterval = interval;
    },
    clearRefreshInterval(state) {
      console.log('CISTIIIM');
      clearInterval(state.refreshInterval);
      state.refreshInterval = null;
    }
  },
  actions: {},
  getters: {
    getUser(state) {
      return state.user;
    },
    getCompany(state) {
      return state.company;
    }
  }
};
